export default "__VITE_ASSET__DU461yNe__"